import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/** Új szervezet létrehozása (onboarding) csak super adminnak – mindenki más meghívóval kerül szervezetbe. */
const OnboardingGate: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return children;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'super_admin') return children;
  return <Navigate to="/" replace />;
};

export default OnboardingGate;
